import { render, staticRenderFns } from "./BarEchart.vue?vue&type=template&id=6c91a9d0&scoped=true"
import script from "./BarEchart.vue?vue&type=script&lang=js"
export * from "./BarEchart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c91a9d0",
  null
  
)

export default component.exports